define('home/templates/confirmResignModerator',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"modal-header\">\n<h4 class=\"modal-title\">"
    + alias2(helpers.gettext.call(alias1,"Resign as moderator of %(name)s",{"name":"gettext","hash":{"name":(depth0 != null ? depth0.name : depth0)},"data":data}))
    + "</h4>\n</div>\n<div class=\"modal-body\">\n<p>"
    + alias2(helpers.gettext.call(alias1,"You will no longer have moderator priveleges on %(name)s.",{"name":"gettext","hash":{"name":(depth0 != null ? depth0.name : depth0)},"data":data}))
    + "</p>\n</div>\n";
},"useData":true})

});
